<template>
  <div class="validation-container">
    <div class="validation-card">
      <div class="header-section">
        <div class="back-button" @click="goBack">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="m12 19-7-7 7-7" />
            <path d="M19 12H5" />
          </svg>
          Torna indietro
        </div>

        <div class="title-section">
          <h1 class="page-title">Validazione Fatture</h1>
          <p class="page-subtitle">Seleziona il tipo di fatture da validare</p>
        </div>
      </div>

      <div class="content-section">
        <div class="info-card">
          <div class="info-icon">
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
              <polyline points="14,2 14,8 20,8" />
              <path d="m9 15 2 2 4-4" />
            </svg>
          </div>

          <div class="info-content">
            <h2>Sistema di Validazione</h2>
            <p>Questo sistema ti permette di validare le fatture generate, verificando i dati e approvando o scartando
              ciascuna fattura con note dettagliate.</p>

            <div class="features-list">
              <div class="feature-item">
                <span class="feature-icon">✓</span>
                <span>Validazione fatture in tempo reale</span>
              </div>
              <div class="feature-item">
                <span class="feature-icon">✓</span>
                <span>Note obbligatorie per ogni decisione</span>
              </div>
              <div class="feature-item">
                <span class="feature-icon">✓</span>
                <span>Tracciamento completo delle operazioni</span>
              </div>
              <div class="feature-item">
                <span class="feature-icon">✓</span>
                <span>Supporto per Luce (POD) e Gas (PDR)</span>
              </div>
            </div>
          </div>
        </div>

        <!-- SEZIONE SCELTA TIPO VALIDAZIONE -->
        <div class="validation-types-section">
          <h3 class="section-title">Scegli il tipo di validazione</h3>

          <div class="validation-options">
            <!-- VALIDAZIONE LUCE -->
            <div class="validation-option luce-option" @click="startValidationLuce" :disabled="isLoadingLuce">
              <div class="option-header">
                <div class="option-icon luce-icon">
                  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" />
                  </svg>
                </div>
                <div class="option-badge luce-badge">POD</div>
              </div>

              <div class="option-content">
                <h4 class="option-title">Validazione Luce</h4>
                <p class="option-description">Valida le fatture di energia elettrica con controllo POD, fasce orarie e
                  potenza</p>

                <div class="option-stats" v-if="statsLuce.loaded">
                </div>

                <div class="option-loading" v-else-if="isLoadingStats">
                  <div class="loading-dots">
                    <span></span><span></span><span></span>
                  </div>
                </div>
              </div>

              <div class="option-footer">
                <button class="option-button luce-button" :disabled="isLoadingLuce">
                  <div class="button-content">
                    <div class="button-icon">
                      <svg v-if="!isLoadingLuce" width="20" height="20" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2">
                        <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" />
                      </svg>
                      <div v-else class="loading-spinner"></div>
                    </div>
                    <span>{{ isLoadingLuce ? 'Caricamento...' : 'Inizia Validazione Luce' }}</span>
                    <div class="button-arrow">→</div>
                  </div>
                </button>
              </div>
            </div>

            <!-- VALIDAZIONE GAS -->
            <div class="validation-option gas-option" @click="startValidationGas" :disabled="isLoadingGas">
              <div class="option-header">
                <div class="option-icon gas-icon">
                  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                    <polyline points="14,2 14,8 20,8" />
                    <line x1="16" y1="13" x2="8" y2="13" />
                    <line x1="16" y1="17" x2="8" y2="17" />
                  </svg>
                </div>
                <div class="option-badge gas-badge">PDR</div>
              </div>

              <div class="option-content">
                <h4 class="option-title">Validazione Gas</h4>
                <p class="option-description">Valida le fatture del gas naturale con controllo PDR, volumi e
                  coefficienti</p>

                <div class="option-stats" v-if="statsGas.loaded">
                </div>

                <div class="option-loading" v-else-if="isLoadingStats">
                  <div class="loading-dots">
                    <span></span><span></span><span></span>
                  </div>
                </div>
              </div>
              <div class="option-footer">
                <button class="option-button gas-button" :disabled="isLoadingGas">
                  <div class="button-content">
                    <div class="button-icon">
                      <svg v-if="!isLoadingGas" width="20" height="20" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2">
                        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                        <polyline points="14,2 14,8 20,8" />
                        <line x1="16" y1="13" x2="8" y2="13" />
                      </svg>
                      <div v-else class="loading-spinner"></div>
                    </div>
                    <span>{{ isLoadingGas ? 'Caricamento...' : 'Inizia Validazione Gas' }}</span>
                    <div class="button-arrow">→</div>
                  </div>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="footer-section">
        <div class="warning-banner">
          <div class="warning-icon">⚠️</div>
          <div class="warning-text">
            <strong>Importante:</strong> Tutte le validazioni richiedono note dettagliate per ogni decisione.
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ValidazioneFattureView',
  data() {
    return {
      isLoadingLuce: false,
      isLoadingGas: false,
      isLoadingStats: true,
      statsLuce: {
        loaded: false,
        pending: 0,
        anomale: 0
      },
      statsGas: {
        loaded: false,
        pending: 0,
        anomale: 0
      }
    };
  },

  methods: {
    goBack() {
      window.history.back();
    },

    async startValidationLuce() {
      this.isLoadingLuce = true;

      try {
        // Simula caricamento
        await new Promise(resolve => setTimeout(resolve, 1000));

        window.location.href = '/previewfatture';
      } catch (error) {
        console.error('Errore avvio validazione luce:', error);
        alert('Errore nell\'avvio del sistema di validazione luce. Riprovare.');
      } finally {
        this.isLoadingLuce = false;
      }
    },
    async startValidationGas() {
      this.isLoadingGas = true;

      try {
        // Simula caricamento
        await new Promise(resolve => setTimeout(resolve, 1000));

        this.$router.push('/previewfatturegas');
      } catch (error) {
        console.error('Errore avvio validazione gas:', error);
        alert('Errore nell\'avvio del sistema di validazione gas. Riprovare.');
      } finally {
        this.isLoadingGas = false;
      }
    },



    async loadStatsLuce() {
      try {

        await new Promise(resolve => setTimeout(resolve, 1500));
        this.statsLuce = {
          loaded: true,
          pending: 15,
          anomale: 3
        };
      } catch (error) {
        console.error('Errore caricamento statistiche luce:', error);
        this.statsLuce = { loaded: true, pending: '—', anomale: '—' };
      }
    },

    async loadStatsGas() {
      try {
        await new Promise(resolve => setTimeout(resolve, 2000));
        this.statsGas = {
          loaded: true,
          pending: 8,
          anomale: 1
        };
      } catch (error) {
        console.error('Errore caricamento statistiche gas:', error);
        this.statsGas = { loaded: true, pending: '—', anomale: '—' };
      }
    },

    async loadAllStats() {
      this.isLoadingStats = true;

      await Promise.all([
        this.loadStatsLuce(),
        this.loadStatsGas()
      ]);

      this.isLoadingStats = false;
    }
  },

  mounted() {
    this.loadAllStats();
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700;800&display=swap');

.validation-container {
  padding: 2rem !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  font-family: 'Montserrat', sans-serif !important;
}

.validation-card {
  background: white;
  border-radius: 20px;
  padding: 2.5rem;
  width: 100%;
  box-shadow: 0 25px 50px rgba(13, 60, 97, 0.3);
  position: relative;
  border: 1px solid rgba(50, 136, 179, 0.1);
}

.header-section {
  margin-bottom: 2.5rem;
}

.back-button {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  color: #215159;
  cursor: pointer;
  font-size: 0.9rem;
  font-weight: 500;
  margin-bottom: 1.5rem;
  transition: all 0.3s ease;
  font-family: 'Montserrat', sans-serif;
}

.back-button:hover {
  color: #0d3c61;
  transform: translateX(-3px);
}

.title-section {
  text-align: center;
}

.page-title {
  font-size: 2.8rem !important;
  font-weight: 700 !important;
  color: #0d3c61 !important;
  margin: 0 0 0.5rem 0 !important;
  font-family: 'Montserrat', sans-serif !important;
  letter-spacing: -0.02em !important;
  position: relative !important;
}

.page-title::after {
  content: '' !important;
  position: absolute !important;
  bottom: -10px !important;
  left: 50% !important;
  transform: translateX(-50%) !important;
  width: 80px !important;
  height: 4px !important;
  background: linear-gradient(90deg, #3288b3, #215159) !important;
  border-radius: 2px !important;
}

.page-subtitle {
  font-size: 1.2rem !important;
  color: #215159 !important;
  margin: 1rem 0 0 0 !important;
  font-weight: 400 !important;
  font-family: 'Montserrat', sans-serif !important;
}

.content-section {
  margin-bottom: 2rem;
}

.info-card {
  background: linear-gradient(135deg, #f8fafb, #e8f4f8);
  border: 1px solid rgba(50, 136, 179, 0.15);
  border-radius: 16px;
  padding: 2.5rem;
  margin-bottom: 2.5rem;
  display: flex;
  gap: 2rem;
  align-items: flex-start;
  transition: all 0.3s ease;
}

.info-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 30px rgba(13, 60, 97, 0.1);
}

.info-icon {
  background: linear-gradient(135deg, #0d3c61, #215159);
  color: white;
  padding: 1.2rem;
  border-radius: 16px;
  flex-shrink: 0;
  box-shadow: 0 8px 20px rgba(13, 60, 97, 0.3);
}

.info-content h2 {
  font-size: 1.6rem;
  font-weight: 600;
  color: #0d3c61;
  margin: 0 0 1.2rem 0;
  font-family: 'Montserrat', sans-serif;
}

.info-content p {
  color: #215159;
  line-height: 1.7;
  margin: 0 0 1.8rem 0;
  font-size: 1rem;
  font-family: 'Montserrat', sans-serif;
}

.features-list {
  display: grid;
  gap: 1rem;
}

.feature-item {
  display: flex;
  align-items: center;
  gap: 1rem;
  font-size: 1rem;
  color: #0d3c61;
  font-family: 'Montserrat', sans-serif;
  font-weight: 500;
}

.feature-icon {
  background: #3288b3;
  color: white;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: bold;
  flex-shrink: 0;
  box-shadow: 0 2px 8px rgba(50, 136, 179, 0.3);
}

/* NUOVI STILI PER SEZIONE VALIDAZIONE */
.validation-types-section {
  margin-bottom: 2rem;
}

.section-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: #0d3c61;
  text-align: center;
  margin: 0 0 2rem 0;
  font-family: 'Montserrat', sans-serif;
}

.validation-options {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 2rem;
}

.validation-option {
  background: white;
  border: 2px solid #e2e8f0;
  border-radius: 20px;
  padding: 2rem;
  cursor: pointer;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  min-height: 300px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
}

/* Overlay per l'hover */
.validation-option::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  opacity: 0;
  transition: opacity 0.4s ease;
  z-index: 1;
}

.luce-option::before {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.gas-option::before {
  background: linear-gradient(135deg, #11998e 0%, #38ef7d 100%);
}

.validation-option:hover::before {
  opacity: 1;
}

/* Assicuriamo che il contenuto sia sopra l'overlay */
.validation-option>* {
  position: relative;
  z-index: 2;
}

.validation-option:hover:not([disabled]) {
  transform: translateY(-12px) scale(1.02);
  box-shadow: 0 30px 60px rgba(0, 0, 0, 0.15);
  border-color: transparent;
  color: white;
}

/* Specifici selettori per hover con priorità alta */
.validation-option.luce-option:hover:not([disabled]) {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
  color: white !important;
  border-color: transparent !important;
}

.validation-option.gas-option:hover:not([disabled]) {
  background: linear-gradient(135deg, #11998e 0%, #38ef7d 100%) !important;
  color: white !important;
  border-color: transparent !important;
}

.luce-option:hover:not([disabled]) {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
  color: white;
  border-color: transparent;
}

.gas-option:hover:not([disabled]) {
  background: linear-gradient(135deg, #11998e 0%, #38ef7d 100%) !important;
  color: white;
  border-color: transparent;
}

.option-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 1.5rem;
}

.option-icon {
  width: 50px;
  height: 50px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.luce-icon {
  background: linear-gradient(135deg, #667eea, #764ba2);
  color: white;
}

.gas-icon {
  background: linear-gradient(135deg, #11998e, #38ef7d);
  color: white;
}

.option-badge {
  padding: 0.3rem 0.8rem;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: 600;
  letter-spacing: 0.5px;
  transition: all 0.3s ease;
}

.luce-badge {
  background: rgba(102, 126, 234, 0.1);
  color: #667eea;
  border: 1px solid rgba(102, 126, 234, 0.2);
}

.gas-badge {
  background: rgba(17, 153, 142, 0.1);
  color: #11998e;
  border: 1px solid rgba(17, 153, 142, 0.2);
}

.validation-option:hover .option-badge {
  background: rgba(255, 255, 255, 0.25);
  color: white;
  border-color: rgba(255, 255, 255, 0.4);
  transform: scale(1.05);
}

.validation-option:hover .option-icon {
  background: rgba(255, 255, 255, 0.25);
  transform: scale(1.15) rotate(5deg);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.2);
}

.option-content {
  flex: 1;
  margin-bottom: 1.5rem;
}

.option-title {
  font-size: 1.4rem;
  font-weight: 700;
  margin: 0 0 0.8rem 0;
  color: #1a202c;
  transition: color 0.3s ease;
  font-family: 'Montserrat', sans-serif;
}

.option-description {
  font-size: 1rem;
  color: #64748b;
  margin: 0 0 1.5rem 0;
  line-height: 1.6;
  transition: color 0.3s ease;
  font-family: 'Montserrat', sans-serif;
}

.validation-option:hover .option-title,
.validation-option:hover .option-description {
  color: white !important;
}

/* Specifici per ogni tipo */
.luce-option:hover .option-title,
.luce-option:hover .option-description,
.gas-option:hover .option-title,
.gas-option:hover .option-description {
  color: white !important;
}

.option-stats {
  display: flex;
  gap: 1.5rem;
  margin-bottom: 1rem;
}

.stat-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
}

.stat-number {
  font-size: 1.8rem;
  font-weight: 700;
  color: #1a202c;
  transition: color 0.3s ease;
  font-family: 'Montserrat', sans-serif;
}

.stat-label {
  font-size: 0.8rem;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-weight: 500;
  transition: color 0.3s ease;
  font-family: 'Montserrat', sans-serif;
}

.validation-option:hover .stat-number,
.validation-option:hover .stat-label {
  color: white;
}

.option-loading {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60px;
}

.loading-dots {
  display: flex;
  gap: 0.3rem;
}

.loading-dots span {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #3288b3;
  animation: loadingDots 1.4s ease-in-out infinite;
}

.loading-dots span:nth-child(1) {
  animation-delay: -0.32s;
}

.loading-dots span:nth-child(2) {
  animation-delay: -0.16s;
}

@keyframes loadingDots {

  0%,
  80%,
  100% {
    transform: scale(0);
  }

  40% {
    transform: scale(1);
  }
}

.option-footer {
  margin-top: auto;
}

.option-button {
  width: 100%;
  background: transparent;
  border: 2px solid #e2e8f0;
  border-radius: 16px;
  padding: 0;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: 'Montserrat', sans-serif;
  overflow: hidden;
}

.luce-button {
  border-color: #667eea;
}

.gas-button {
  border-color: #11998e;
}

.validation-option:hover .option-button {
  background: rgba(255, 255, 255, 0.25);
  border-color: rgba(255, 255, 255, 0.5);
  color: white;
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
}

.button-content {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem 1.5rem;
}

.button-icon {
  flex-shrink: 0;
}

.button-content span {
  flex: 1;
  font-weight: 600;
  font-size: 1rem;
  text-align: left;
}

.button-arrow {
  font-size: 1.2rem;
  font-weight: bold;
  transition: transform 0.3s ease;
}

.validation-option:hover .button-arrow {
  transform: translateX(5px);
}

.loading-spinner {
  width: 20px;
  height: 20px;
  border: 2px solid rgba(102, 126, 234, 0.3);
  border-top: 2px solid #667eea;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

.validation-option:hover .loading-spinner {
  border-color: rgba(255, 255, 255, 0.3);
  border-top-color: white;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.footer-section {
  margin-top: 2.5rem;
}

.warning-banner {
  background: linear-gradient(135deg, #fff8e1, #ffecb3);
  border: 1px solid #3288b3;
  border-radius: 12px;
  padding: 1.5rem;
  display: flex;
  align-items: center;
  gap: 1rem;
}

.warning-icon {
  font-size: 1.5rem;
  flex-shrink: 0;
}

.warning-text {
  color: #0d3c61;
  font-size: 0.95rem;
  line-height: 1.5;
  font-family: 'Montserrat', sans-serif;
  font-weight: 500;
}

.warning-text strong {
  color: #0d3c61;
  font-weight: 600;
}

/* Responsive Design */
@media (max-width: 1024px) {
  .validation-options {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }
}

@media (max-width: 768px) {
  .validation-container {
    padding: 1rem;
  }

  .validation-card {
    padding: 2rem;
  }

  .page-title {
    font-size: 2.2rem;
  }

  .page-subtitle {
    font-size: 1.1rem;
  }

  .info-card {
    flex-direction: column;
    text-align: center;
    padding: 2rem;
  }

  .validation-option {
    min-height: 250px;
    padding: 1.5rem;
  }

  .option-stats {
    gap: 1rem;
  }

  .stat-number {
    font-size: 1.5rem;
  }
}

@media (max-width: 480px) {
  .validation-container {
    padding: 0.8rem;
  }

  .validation-card {
    padding: 1.5rem;
    border-radius: 16px;
  }

  .page-title {
    font-size: 1.9rem;
  }

  .page-subtitle {
    font-size: 1rem;
  }

  .info-card {
    padding: 1.5rem;
  }

  .validation-option {
    min-height: 220px;
    padding: 1.25rem;
  }

  .option-title {
    font-size: 1.2rem;
  }

  .option-description {
    font-size: 0.9rem;
  }

  .warning-banner {
    flex-direction: column;
    text-align: center;
    padding: 1.2rem;
  }
}

/* Animazioni */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.validation-card {
  animation: fadeInUp 0.6s ease-out;
}

.info-card {
  animation: fadeInUp 0.8s ease-out;
}

.validation-option:nth-child(1) {
  animation: fadeInUp 1s ease-out;
}

.validation-option:nth-child(2) {
  animation: fadeInUp 1.2s ease-out;
}
</style>